'use client';

import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Spinner — shared inline loading indicator (animated Loader2).
 *
 * Replaces the hand-rolled `<Loader2 className="... animate-spin" />` pattern
 * that was being copy-pasted across feature components (the duplication
 * `submit-button-pattern` ratchet flags). Decorative by default
 * (`aria-hidden`) — pair it with adjacent visible text. Pass `label` to make
 * it a standalone, announced status indicator.
 */
export interface SpinnerProps {
  /** Size / colour overrides. Defaults to `h-4 w-4`. */
  className?: string;
  /**
   * When set, the spinner is announced to assistive tech as a status with
   * this label (`role="status"`). Omit when adjacent text already conveys it.
   */
  label?: string;
}

export function Spinner({ className, label }: SpinnerProps) {
  return (
    <Loader2
      className={cn('h-4 w-4 animate-spin', className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
